import { css } from '@emotion/react';

const SubSectionsStyles = css`
    .section-labels {
        display: flex;

        .sub-section-label {
            padding: 1rem;
        }

        .active {
            background-color: lightgray;
        }
    }

    .sub-section-content {
        display: none;
        width: 100%;
    }

    .show {
        display: inline-block;
    }
`;

export const themeSubSectionStyles = css`
    font-family: var(--font-family-regular);
    font-size: var(--font-size-regular);

    .section-labels {
        overflow-x: auto;

        ::-webkit-scrollbar {
            width: 0; /* Set width to 0 to hide the scrollbar */
        }

        /* Styling the scrollbar track and thumb to hide it further on other browsers*/
        ::-webkit-scrollbar-track {
            background: #ffffff;
        }

        ::-webkit-scrollbar-thumb {
            background: #ffffff;
        }

        ::-webkit-scrollbar-thumb:hover {
            background: #ffffff;
        }

        .arrow-icon {
            position: absolute;

            &.arrow-icon-right,
            .arrow-image-right {
                right: 5px;
            }

            &.arrow-icon-left,
            .arrow-image-left {
                left: 5px;
            }
        }
    }
`;

export const tabsPanelStyles = css`
    .section-labels {
        display: flex;

        .sub-section-labels {
            display: flex;
            width: 100%;
            justify-content: space-between;
        }

        .sub-section-label {
            width: 100%;
            padding: 1rem 0;
            text-align: center;
            border-bottom: 5px solid var(--color-grey);
            cursor: pointer;
        }

        .active {
            background-color: transparent !important;
            border-bottom: 5px solid var(--color-primary);
            font-weight: 700;
        }

        .toggle-labels {
            display: none;
        }
    }
`;

export default SubSectionsStyles;
